export default __webpack_public_path__ + "static/media/pool-logo-white.b00b7d09.png";